<template>
  <breadcrumb :links="{'/': 'Home', 'current': 'Licenza d’uso'}"></breadcrumb>

  <div>

    <div class="section section_odd">
      <div class="container-xl">
        <h1>Licenza d’uso</h1>
        <p>
          La Regione Friuli Venezia Giulia regola l’accesso ai propri dati con la <strong>legge regionale 17 aprile 2014, n. 7</strong> 
          recante “Disposizioni in materia di dati aperti e loro riutilizzo”.
        </p>
        <p>
          In attuazione della suddetta legge regionale è stata emenata la <strong>delibera della Giunta regionale 30 dicembre 2014 n. 2626</strong>
          "Regole in materia di dati aperti e loro utilizzo".
        </p>
        <p>
          Per quanto riguarda le licenze d’uso il regolamento fa riferimento alle <strong>Linee guida nazionali per la valorizzazione del patrimonio informativo pubblico</strong>
          pubblicate dall’Agenzia per l’Italia digitale, che nella loro ultima revisione consigliano l’addozione della licenza <strong>CC-BY nella sua versione 4.0</strong>.
        </p>
        <p>
          Per utilizzare i contenuti è necessario citare esplicitamente la fonte con questa dicitura: <strong>"Fonte: Protezione Civile della Regione Friuli Venezia Giulia"</strong>.
        </p>
      </div>
    </div>
    <div class="section section_even">
      <div class="container-xl">
        <p>
          Rimandando al testo originale della licenza, un riassunto dei termini di utilizzo è il seguente:
        </p>
        <h2>Tu sei libero di:</h2>
        <p><strong>Condividere</strong> — riprodurre, distribuire, comunicare al pubblico, esporre in pubblico, rappresentare, eseguire e recitare questo materiale con qualsiasi mezzo e formato.</p>
        <p><strong>Modificare</strong> — remixare, trasformare il materiale e basarti su di esso per le tue opere per qualsiasi fine, anche commerciale. </p>
        <h2>Alle seguenti condizioni:</h2>
        <p><strong>Attribuzione</strong> — Devi riconoscere una menzione di paternità adeguata, fornire un link alla licenza e indicare se sono state effettuate delle modifiche. Puoi fare ciò in qualsiasi maniera ragionevole possibile, ma non con modalità tali da suggerire che il licenziante avalli te o il tuo utilizzo del materiale.</p>
        <p><strong>Divieto di restrizioni aggiuntive</strong> — Non puoi applicare termini legali o misure tecnologiche che impongano ad altri soggetti dei vincoli giuridici su quanto la licenza consente loro di fare. </p>
        <h2>Note:</h2>
        <p>Non sei tenuto a rispettare i termini della licenza per quelle componenti del materiale che siano in pubblico dominio o nei casi in cui il tuo utilizzo sia consentito da una eccezione o limitazione prevista dalla legge.</p>
        <p>Non sono fornite garanzie. La licenza può non conferirti tutte le autorizzazioni necessarie per l’utilizzo che ti prefiggi. Ad esempio, diritti di terzi come i diritti all'immagine, alla riservatezza e i diritti morali potrebbero restringere gli usi che ti prefiggi sul materiale.</p>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
  
</template>

<script>
  import AppFooter from '@/app-footer.vue'
  import Breadcrumb from '@/components/Breadcrumb'

  export default {
    components: {AppFooter, Breadcrumb}
  }
</script>

<style scoped lang="scss">
  .section {
    padding-top: 20px;
  }
</style>